const baseURL = '/api/v1/file';

export default {
  FILE_SUGGESTION: (fileUuid: string) => `${baseURL}/${fileUuid}/suggestions`,
  FILE_CHAT: (fileUuid: string) => `${baseURL}/${fileUuid}/chat`,
};
